import { useSnackbar, VariantType, WithSnackbarProps } from 'notistack';
import React from 'react';

interface IProps {
  setUseSnackbarRef: (showSnackbar: WithSnackbarProps) => void;
}

const InnerSnackbarUtilsConfigurator: React.FC<IProps> = (props: IProps) => {
  // eslint-disable-next-line react/destructuring-assignment
  props.setUseSnackbarRef(useSnackbar());
  return null;
};

let useSnackbarRef: WithSnackbarProps;
const setUseSnackbarRef = (useSnackbarRefProp: WithSnackbarProps) => {
  useSnackbarRef = useSnackbarRefProp;
};

export const SnackbarUtilsConfigurator: React.FC<any> = () => {
  return (
    <InnerSnackbarUtilsConfigurator setUseSnackbarRef={setUseSnackbarRef} />
  );
};

export default {
  success(msg: string): void {
    this.toast(msg, 'success');
  },
  warning(msg: string): void {
    this.toast(msg, 'warning');
  },
  info(msg: string): void {
    this.toast(msg, 'info');
  },
  error(msg: string): void {
    this.toast(msg, 'error');
  },
  toast(msg: string, variant: VariantType = 'default'): void {
    useSnackbarRef.enqueueSnackbar(msg, { variant });
  },
};
